import urls from "../constants";
import { useFetch } from "./useFetch";

export function useAuthentication() {
    const { sendPost } = useFetch();

    const authenticate = async (email, password) => {
        try {
            const response = await sendPost(urls.AUTHENTICATION_URL, { }, 
                JSON.stringify({email, password})
            );
            return response;
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    return { authenticate };
}